<template>
  <div class="Nosotros">
    <div class="banner">
      <div class="banner-box">
        <div class='tag'>Términos y Condiciones Generales de Uso</div>
        <img src="@/assets/imgs/img33.png" class="img32" />
      </div>
    </div>
    <template>
      <div class="content">
        <div class="description">
          Este contrato describe los términos y condiciones generales (los
          "Términos y Condiciones Generales") aplicables al uso de los servicios
          ofrecidos por Previcrem, S.A. de C.V., SOFOM, E.N.R., (en lo sucesivo
          “Paay Prima”) (en conjunto "los Servicios") dentro del sitio Paay
          Prima, que deriven de todos aquellos dominios de los que Paay Prima
          sea propietario y/o su(s) aplicación(es) móvil(es) propias o de
          terceros (“App(s)”) y, en general, todos sus desarrollos tecnológicos
          presentes o futuros (en conjunto con las Páginas Web y las Apps, las
          “Plataformas”), serán referidos en las Plataformas y en estos Términos
          y Condiciones Generales, indistintamente como Paay Prima. Cualquier
          persona que desee acceder y/o usar las Plataformas o los servicios
          podrá hacerlo sujetándose a los Términos y Condiciones Generales,
          junto con todas las demás políticas y principios que rigen Paay Prima y
          que son incorporados al presente por referencia.
        </div>
        <div class="paragraph">
          CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES
          GENERALES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO Y VINCULANTE,
          DEBERÁ ABSTENERSE DE UTILIZAR LAS PLATAFORMAS Y/O LOS SERVICIOS.
        </div>
        <div class="description margin-b32">
          El Usuario debe leer, entender y aceptar todas las condiciones
          establecidas en los Términos y Condiciones Generales y en el Aviso de
          Privacidad así como en los demás documentos incorporados a los mismos
          por referencia, previo a su inscripción como Usuario de Paay Prima.
        </div>
        <div class="paragraph margin-b8">A. LEGITIMACIÓN</div>
        <div class="description margin-b32">
          Los Servicios sólo están disponibles para personas que tengan
          capacidad legal para contratar. No podrán utilizar los servicios las
          personas que no tengan esa característica, los menores de edad o
          Usuarios de Paay Prima que hayan sido suspendidos temporalmente o
          inhabilitados definitivamente. Si estás inscribiendo un Usuario como
          Empresa, debes tener capacidad para contratar a nombre de tal entidad
          y de obligar a la misma en los términos de este Acuerdo y estar
          legitimados con facultades de representación legal para actos de
          administración, en los términos del segundo párrafo del artículo 2554
          del Código Civil Federal, en relación con el artículo 2° del Código de
          Comercio, otorgado ante fedatario público, aunque no se encuentre
          inscrito en el Registro Público de Comercio en los términos del
          artículo 21, fracción VII del citado Código de Comercio.
        </div>
        <div class="paragraph margin-b8">B. DATOS PERSONALES</div>
        <div class="description margin-b32">
          Es obligatorio completar el formulario de inscripción en todos sus
          campos con datos personales válidos para poder utilizar los servicios
          que brinda Paay Prima. El futuro Usuario deberá completarlo con su
          información personal de manera exacta, precisa y verdadera ("Datos
          Personales") y asume el compromiso de actualizar los Datos Personales
          conforme resulte necesario. Paay Prima podrá utilizar diversos medios
          para identificar a sus Usuarios así como solicitar Medios electrónicos
          de Autentificación y Reportes de Crédito, pero Paay Prima NO se
          responsabilizar por la certeza de los Datos Personales provistos por
          sus Usuarios. Los Usuarios garantizan y responden, en cualquier caso,
          de la veracidad, exactitud, vigencia y autenticidad de los Datos
          Personales ingresados. Paay Prima se reserva el derecho de solicitar
          algún comprobante y/o dato adicional a efectos de corroborar los Datos
          Personales, así como de suspender temporal o definitivamente a
          aquellos Usuarios cuyos datos no hayan podido ser confirmados. El
          Usuario accederá a su cuenta personal ("Cuenta") mediante el ingreso
          de su clave y contraseña elegida ("Clave de Seguridad"). El Usuario se
          obliga a mantener la confidencialidad de su Clave de Seguridad. La
          Cuenta es personal, única e intransferible, y está prohibido que un
          mismo Usuario inscriba o posea más de una Cuenta. En caso que Paay
          Prima detecte distintas Cuentas que contengan datos coincidentes o
          relacionados, podrá cancelar, suspender o inhabilitarlas. El Usuario
          será responsable por todas las operaciones efectuadas en su Cuenta,
          pues el acceso a la misma está restringido al ingreso y uso de su
          Clave de Seguridad, de conocimiento exclusivo del Usuario. El Usuario
          se compromete a notificar a Paay Prima en forma inmediata y por medio
          idóneo y fehaciente, cualquier uso no autorizado de su Cuenta, así
          como el ingreso por terceros no autorizados a la misma. Se aclara que
          está prohibida la venta, cesión o transferencia de la Cuenta
          (incluyendo la reputación y calificaciones) bajo ningún título. Paay
          Prima se reserva el derecho de rechazar cualquier solicitud de
          inscripción o de cancelar una inscripción previamente aceptada, sin
          que esté obligado a comunicar o exponer las razones de su decisión y
          sin que ello genere algún derecho a indemnización o resarcimiento. No
          obstante, en caso de que la aplicación sea rechazada por causas
          imputables al Usuario, Paay Prima podrá mostrarles otras opciones que
          se ajusten a su capacidad de pago con la finalidad de facilitar el
          acceso al crédito, sin que esto signifique obligación por parte del
          solicitante de aceptar dichas opciones.
        </div>
        <div class="paragraph margin-b8">C. PERMISO DE REPORTES DE CRÉDITO</div>
        <div class="description margin-b32">
          El usuario da Consentimiento para utilizar medios electrónicos de
          autenticación. Las partes acuerdan que el Usuario podrá expresar su
          consentimiento respecto al presente (enlace contrato), así como tener
          acceso a los servicios ofrecidos por Previcrem, Previcrem, S.A. de C.V., SOFOM, E.N.R., mediante medio electrónicos tale como NIP. El usuario da
          Autorización para solicitar Reportes de Crédito Autorizo expresamente
          a Previcrem, S.A. de C.V., SOFOM, E.N.R., para que lleve a cabo
          Investigaciones sobre comportamiento Crediticio en las Sociedades de
          Información Crediticia (SIC) que estime conveniente. Conozco la
          naturaleza y alcance de la información que se solicitará, del uso se
          le dará y que se pondrán realizar consultar periódicas de mi historial
          crediticio. Consiento que esta autorización tenga vigencia de 3 años
          contados a partir de hoy, y en su caso mientras mantengamos relación
          jurídica. Acepto que este documento quede bajo propiedad de Previcrem, S.A. de C.V., SOFOM, E.N.R. y/o SIC Consultada) para efectos de
          control de cumplimiento del artículo 28 de LRSIC.
        </div>
        <div class="paragraph margin-b8">D. MODIFICACIONES</div>
        <div class="description margin-b32">
          Paay Prima podrá modificar los Términos y Condiciones Generales en
          cualquier momento haciendo públicos en las Plataformas los términos
          modificados. Todos los términos modificados entrarán en vigor a los 10
          (diez) días de su publicación. Dentro de los 5 (cinco) días siguientes
          a la publicación de las modificaciones introducidas, el Usuario deberá
          comunicar por e-mail si no acepta las mismas; en ese caso quedará
          disuelto el vínculo contractual y será inhabilitado como Usuario
          siempre que no tenga deudas pendientes. Vencido este plazo, se
          considerará que el Usuario acepta los nuevos términos y el contrato
          continuará vinculando a ambas partes.
        </div>
        <div class="paragraph margin-b8">E. PRIVACIDAD DE LA INFORMACIÓN</div>
        <div class="description margin-b32">
          Para utilizar los Servicios ofrecidos por Paay Prima, los Usuarios
          deberán facilitar determinados datos de carácter personal. Su
          información personal se procesa y almacena en servidores o medios
          magnéticos que mantienen altos estándares de seguridad y protección
          tanto física como tecnológica. Para mayor información sobre la
          privacidad de los Datos Personales y casos en los que será revelada la
          información personal, se puede consultar nuestro Aviso de Privacidad.
        </div>
        <div class="paragraph margin-b8">
          F. VIOLACIONES DEL SISTEMA O BASES DE DATOS
        </div>
        <div class="description margin-b32">
          No está permitida ninguna acción o uso de dispositivo, software, u
          otro medio tendiente a interferir tanto en las actividades y
          operatoria de Paay Prima como en la base de datos. Cualquier
          intromisión, tentativa o actividad violatoria o contraria a las leyes
          sobre derecho de propiedad intelectual y/o a las prohibiciones
          estipuladas en este contrato harán pasible a su responsable de las
          acciones legales pertinentes, y a las sanciones previstas por este
          acuerdo, así como lo hará responsable de indemnizar los daños
          ocasionados.
        </div>
        <div class="paragraph margin-b8">
          G. SANCIONES. SUSPENSIÓN DE OPERACIONES
        </div>
        <div class="description margin-b32">
          Sin perjuicio de otras medidas, Paay Prima podrá advertir, suspender en
          forma temporal o inhabilitar definitivamente la Cuenta de un Usuario o
          una publicación, aplicar una sanción que impacte negativamente en la
          reputación de un Usuario, iniciar las acciones que estime pertinentes
          y/o suspender la prestación de sus Servicios si: (a) se quebrantara
          alguna ley, o cualquiera de las estipulaciones de los Términos y
          Condiciones Generales y demás políticas de Paay Prima; (b) si
          incumpliera sus compromisos como Usuario; (c) si se incurriera a
          criterio de Paay Prima en conductas o actos dolosos o fraudulentos; (d)
          no pudiera verificarse la identidad del Usuario o cualquier
          información proporcionada por el mismo fuere errónea; (e) Paay Prima
          entendiera que las publicaciones u otras acciones pueden ser causa de
          responsabilidad para el Usuario que las publicó.
        </div>
        <div class="paragraph margin-b8">H. RESPONSABILIDAD</div>
        <div class="description margin-b32">
          Paay Prima recomienda actuar con prudencia y sentido común al momento
          de realizar operaciones con otros Usuarios. El Usuario debe tener
          presente además, los riesgos de contratar con menores o con personas
          que se valgan de una identidad falsa. En caso de que uno o más
          Usuarios o algún tercero inicien cualquier tipo de reclamo o acciones
          legales contra otro u otros Usuarios, todos y cada uno de los Usuarios
          involucrados en dichos reclamos o acciones eximen de toda
          responsabilidad a Paay Prima y a sus directores, gerentes, empleados,
          agentes, operarios, representantes y apoderados.
        </div>
        <div class="paragraph margin-b8">I. FALLAS EN EL SISTEMA</div>
        <div class="description margin-b32">
          Paay Prima no se responsabiliza por cualquier daño, perjuicio o pérdida
          al Usuario causados por fallas en el sistema, en el servidor o en
          Internet. Paay Prima tampoco será responsable por cualquier virus que
          pudiera infectar el equipo del Usuario como consecuencia del acceso,
          uso o examen de sus plataformas o a raíz de cualquier transferencia de
          datos, archivos, imágenes, textos, o audio contenidos en el mismo, así
          como cualquier otra información enviada con el uso de medios
          electrónicos. Los Usuarios NO podrán imputarle responsabilidad alguna
          ni exigir pago por lucro cesante, en virtud de perjuicios resultantes
          de dificultades técnicas o fallas en los sistemas o en Internet. Paay
          Prima no garantiza el acceso y uso continuado o ininterrumpido de sus
          plataformas. El sistema puede eventualmente no estar disponible debido
          a dificultades técnicas o fallas de Internet, o por cualquier otra
          circunstancia ajena a Paay Prima; en tales casos se procurará
          restablecerlo con la mayor celeridad posible sin que por ello pueda
          imputársele algún tipo de responsabilidad. Paay Prima no será
          responsable por ningún error u omisión contenidos en sus plataformas.
        </div>
        <div class="paragraph margin-b8">J. VERIFICACIÓN DE IDENTIDAD</div>
        <div class="description margin-b32">
          Debido a que la verificación de la identidad de los Usuarios en
          Internet es difícil, Paay Prima no puede confirmar ni confirma la
          identidad pretendida de cada Usuario. Por ello el Usuario cuenta con
          un sistema de información de Usuarios que es actualizado
          periódicamente en base a datos vinculados con su actividad en las
          Plataformas y a los comentarios ingresados por los Usuarios según las
          operaciones que hayan realizado. Este sistema de información, además
          constará de un espacio donde los Usuarios podrán hacer comentarios y
          réplicas a las calificaciones recibidas y acceder a los mismos. Dichos
          comentarios serán incluidos bajo exclusiva responsabilidad de los
          Usuarios que los emitan. En virtud que las verificaciones de
          identidad, comentarios y réplicas son realizados por los Usuarios y
          por consecuencia son datos personales, éstos serán incluidos bajo
          exclusiva responsabilidad de los Usuarios que los emitan.
        </div>

        <div class="paragraph margin-b8">K. PROPIEDAD INTELECTUAL</div>
        <div class="description margin-b32">
          Los contenidos de las pantallas relativas a los servicios de Paay Prima
          como así también los programas, bases de datos, redes, archivos que
          permiten al Usuario acceder y usar su Cuenta, son de la titularidad y
          propiedad de Paay Prima y por consecuencia están protegidas por las
          normas internacionales de derecho de autor, marcas, patentes, modelos
          y diseños industriales. El uso indebido y la reproducción total o
          parcial de dichos contenidos quedan prohibidos, salvo autorización
          expresa y por escrito de Paay Prima.
        </div>
        <div class="paragraph margin-b8">L. INDEMNIZACIÓN</div>
        <div class="description margin-b32">
          El Usuario indemnizará y mantendrá indemne a Paay Prima, sus filiales,
          empresas controladas y/o controlantes, directivos, administradores,
          representantes y empleados, por cualquier reclamo o demanda de otros
          Usuarios o terceros por sus actividades en las Plataformas o por su
          incumplimiento los Términos y Condiciones Generales y demás Políticas
          que se entienden incorporadas al presente o por la violación de
          cualesquiera leyes o derechos de terceros, incluyendo los honorarios
          de abogados en una cantidad razonable.
        </div>
        <div class="paragraph margin-b8">N. DOMICILIO</div>
        <div class="description margin-b32">
          Este acuerdo estará regido en todos sus puntos por las leyes vigentes
          en la República Mexicana, en particular respecto de mensajes de datos,
          contratación electrónica y comercio electrónico se regirá por lo
          dispuesto por la legislación federal respectiva. Cualquier
          controversia derivada del presente acuerdo, su existencia, validez,
          interpretación, alcance o cumplimiento, será sometida a las leyes
          aplicables y a los Tribunales competentes. Para la interpretación,
          cumplimiento y ejecución del presente contrato, las partes
          expresamente se someten a la jurisdicción de los tribunales federales
          competentes de la Ciudad de México, renunciando en consecuencia a
          cualquier fuero que en razón de su domicilio presente o futuro pudiera
          corresponderles.
        </div>

        <div class="paragraph margin-b8">M. JURISDICCIÓN Y LEY APLICABLE</div>
        <div class="description margin-b32">
          Se fija como domicilio de Paay Prima Avenida Fundadores 955 , interior Piso 16, Oficina 1, Colonia Zona Valle Oriente Norte, C.P. 66266, San Pedro Garza García, Nuevo León Para lo no previsto en
          estos Términos y Condiciones, los Clientes acuerdan someterse a las
          leyes aplicables de los Estados Unidos Mexicanos. Para la
          interpretación y ejecución de los presentes Términos y Condiciones, el
          Cliente acepta someterse a la jurisdicción y competencia de los
          tribunales competentes de Ciudad de México, renunciando expresamente
          al fuero que pudiese corresponderle por razón de su domicilio presente
          o futuro.
        </div>

        <div class="paragraph margin-b8">O. ADVERTENCIA</div>
        <div class="description margin-b32">
          <div>
            Incumplir tus obligaciones te puede generar comisiones e intereses
            moratorios.
          </div>
          <div>
            Contratar créditos por arriba de tu capacidad de pago puede afectar
            tu historial crediticio.
          </div>
          <div>Fecha de última actualización: 2026.5.25</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Nosotros',
  components: {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
.banner {
  padding: 0 360px;
  margin-top: 70px;
  margin-bottom: 22px;
}
.banner-box {
  height: 84px;
  background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
  border-radius: 34px 34px 0px 0px;
  padding: 0 45px;
  display: flex;
  align-items: center;
  position: relative;
}
.img32 {
  position: absolute;
  width: 138px;
  height: 138px;
  bottom: 0;
  right: 22px;
}
.banner-box div {
  margin-right: 75px;
  font-size: 16px;
  color: #977f6a;
  cursor: pointer;
}
.tag {
  position: relative;
  color: #000000 !important;
  font-weight: bold;
}
.tag::after {
  content: ' ';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff4134;
  position: absolute;
  left: -18px;
  top: 8px;
}

.content {
  padding: 0 410px;
}

.description {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 16px;
}
.paragraph {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 16px;
}
.margin-b8 {
  margin-bottom: 8px;
}
.margin-b32 {
  margin-bottom: 32px;
}
.font-weight {
  font-weight: bold;
}
.c-table {
  border: 1px solid #979797;
  margin-bottom: 14px;
}
.row {
  height: 64px;
  border-bottom: 1px solid #979797;
  padding: 0 26px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.row span {
  display: flex;
  align-items: center;
}
.lei1 {
  width: 30%;
}
.lei2 {
  width: 40%;
}
.lei3 {
  width: 20%;
}
.row-1 {
  background: #fff8f2;
  font-weight: bold;
}

@media (max-width: 768px) {
  .content {
    padding: 0 140px;
  }
  .paragraph {
    font-size: 65px;
    line-height: 110px;
    margin: 50px 0;
  }
  .description {
    font-size: 65px;
    line-height: 120px;
  }

  .banner {
    padding: 0 140px;
  }
  .banner-box {
    height: 384px;
    background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
    border-radius: 34px 34px 0px 0px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .banner-box div {
    font-size: 65px;
    color: #977f6a;
    cursor: pointer;
    margin-right: 0;
    flex: 1;
    text-align: center;
  }
  .tag {
    margin-right: 0;
  }
  .tag::after {
    content: ' ';
    width: 0;
    height: 0;
  }
  .img32 {
    display: none;
  }
}
</style>
